var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { HyperlinkTargetEnum } from '@inter-ikea-kompis/component-hyperlink';
import { Hyperlink } from '@inter-ikea-kompis/component-hyperlink';
import { Text } from '@inter-ikea-kompis/component-text';
/**
 * Financial services link.
 *
 * @event linkClick Triggered when the user clicks on the financial services button link.
 */
export default class FinancialServicesLink extends KompisElement {
    constructor() {
        super(...arguments);
        // Disables links. This attribute should be set to "true" when in a Kiosk.
        this.disableLinks = false;
    }
    render() {
        return html `<kompis-text
			.theme="${this.theme}"
			.type="${ThemeFontStyleTypeEnum.bodyMedium}"
			.bold="${true}"
		>
			${this.getHyperLink()}
		</kompis-text>`;
    }
    connectedCallback() {
        this.customElements.define('kompis-hyperlink', Hyperlink);
        this.customElements.define('kompis-text', Text);
        super.connectedCallback();
    }
    getHyperLink() {
        const { anchor, anchorLink } = this.financingOption;
        if (anchorLink && !this.disableLinks) {
            return html `<kompis-hyperlink
				.theme="${this.theme}"
				.text="${anchor}"
				.underline="${true}"
				.href="${anchorLink}"
				.target="${HyperlinkTargetEnum.blank}"
			>
			</kompis-hyperlink>`;
        }
        return html `<kompis-hyperlink
			.theme="${this.theme}"
			.text="${anchor}"
			.underline="${true}"
			@linkClick="${() => this.dispatchEvent(new CustomEvent('linkClick', {
            bubbles: true,
            detail: { triggerElement: this.getTriggerElement() }
        }))}}"
		>
		</kompis-hyperlink>`;
    }
    getTriggerElement() {
        const hyperLink = this.shadowRoot?.querySelector(this.customElements.getInternalName('kompis-hyperlink'));
        const focusOutline = hyperLink?.shadowRoot?.querySelector(hyperLink.customElements.getInternalName('kompis-focus-outline'));
        return focusOutline?.querySelector('a');
    }
}
__decorate([
    property({ type: Object, required: true })
], FinancialServicesLink.prototype, "financingOption", void 0);
__decorate([
    property({ type: Boolean })
], FinancialServicesLink.prototype, "disableLinks", void 0);
__decorate([
    property({ type: Object, required: true })
], FinancialServicesLink.prototype, "theme", void 0);
//# sourceMappingURL=FinancialServicesLink.js.map